import MultiDropDown from '../../../../../../../components/MultiDropDown';
import {
  faMagnifyingGlass,
  faTableColumns,
  faSort,
  faFileCircleCheck,
  faMessageLines,
  faPaperclip,
  faSquarePlus,
  faBookOpen
} from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Accordion, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import {
  useGetAssignmentCrGradingQuery,
  useUpdateCrAnswerMutation,
  useGetHtmlContentMutation
} from '../../../../../../../features/authentication/assignmentApislice';
import { useParams } from 'react-router-dom';
import '../../../../../assignments.scss';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../../../../../../features/authentication/authSlice';
import LoadingOverlay from '../../../../../../../components/loadingOverlay/loadingOverlay';
import TeacherCommentModal from './components/teacherCommentModal';
import StudentUploadedFilesModal from './components/studentUploadedFilesModal';
import ViewAllStudentAnswerModal from './components/viewAllStudentAnswerModal';
import { useAssignmentContext } from '../../../../../context';
import FERPA from '../../../../../../../components/FERPA/FerpaComponent';

function GradeCrQuestions() {
  const [pageLoading, setPageLoading] = useState(true);
  const ferpaEnabled = useSelector(selectFerpaState);
  const { assignmentName, setAssignmentName } = useAssignmentContext();
  const { assignmentId } = useParams();
  const { refetch: refetchData, isError: dataError } = useGetAssignmentCrGradingQuery({
    assignmentId: assignmentId,
    pageNumber: 0,
    pageSize: 25
  });
  const [scoreCrAnswer] = useUpdateCrAnswerMutation();
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [classList, setClassList] = useState([]);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
  const [statusFilterOption, setStatusFilterOption] = useState(0);
  const sortByAscending = useRef(true);
  const sortResultsBy = useRef('sort-student');
  const [studentNameFilter, setStudentNameFilter] = useState('');
  const [showColumnFilterOptions, setShowColumnFilterOptions] = useState(false);
  const [selectedColumnFilters, setSelectedColumnFilters] = useState([
    'Student',
    'Class',
    'Status',
    'Score',
    'Un-finalize Response',
    'Retake',
    'Answer'
  ]);
  const [assignmentQuestions, setAssignmentQuestions] = useState([]);
  const [displayStudentAnswerData, setDisplayStudentAnswerData] = useState([]);
  const [hideRetakes, setHideRetakes] = useState(false);
  const [showStudentFilesModal, setShowStudentFilesModal] = useState(false);
  const [showTeacherCommentModal, setShowTeacherCommentModal] = useState(false);
  const [showViewAllAnswerModal, setShowViewAllAnswerModal] = useState(false);
  const [htmContent, setHtmContent] = useState('');
  const teacherCommentModalData = useRef({
    sessionId: null,
    studentId: null,
    questionId: null,
    teacherComment: null
  });
  const studentFilesModalData = useRef(null);
  const studentAnswerModalData = useRef(null);
  const filterColumnRef = useRef(null);
  const answerCellRefs = useRef([]);
  const [getHtmlContent] = useGetHtmlContentMutation();
  const [showResourceOptions, setShowResourceOptions] = useState(false);
  const [error, setError] = useState('');

  const crAnswerStatuses = [
    { statusId: 0, backgroundColor: '#FFE3E3', foregroundColor: '#F84646', text: 'Not Answered' },
    { statusId: 1, backgroundColor: '#E3FFF6', foregroundColor: '#48E0B2', text: 'Answered' },
    { statusId: 2, backgroundColor: '#FFF1E1', foregroundColor: '#F7931E', text: 'In Progress' },
    { statusId: 3, backgroundColor: '#E3FFF6', foregroundColor: '#48E0B2', text: 'Answered' },
    { statusId: 4, backgroundColor: '#E3FFF6', foregroundColor: '#48E0B2', text: 'Answered' }
  ];

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    for (var i = 0; i < answerCellRefs.current.length; i++) {
      if (
        answerCellRefs.current[i] &&
        answerCellRefs.current[i].offsetHeight < answerCellRefs.current[i].scrollHeight
      ) {
        document.getElementById(`studentViewAll_${i}`).style.display = 'flex';
      }
    }
  }, [
    selectedQuestionIndex,
    studentNameFilter,
    hideRetakes,
    selectedClassIds,
    ferpaEnabled,
    statusFilterOption
  ]);

  useEffect(() => {
    const tempStudentAnswers = displayStudentAnswerData?.map((item) => {
      let tempUploadFiles = [];
      item.uploadedFiles?.map((file) => {
        if (file.questionId === assignmentQuestions[selectedQuestionIndex].questionId)
          tempUploadFiles.push(file);
      });
      return { ...item, questionUploadedFiles: tempUploadFiles };
    });
    setDisplayStudentAnswerData(tempStudentAnswers);
  }, [selectedQuestionIndex]);

  function refetch() {
    refetchData().then((response) => {
      if (!response.isSuccess) {
        setPageLoading(false);
        return;
      }

      setAssignmentName(response.data.assignmentName);
      setAssignmentQuestions(response.data.assignmentQuestions);
      setClassList(
        response.data.classes.map((item) => {
          return {
            name: item.name,
            id: item.id,
            description: item.coTeacherName,
            isChecked: item.selected
          };
        })
      );
      setSelectedClassIds(response.data.classes.map((item) => item.id));
      setDisplayStudentAnswerData(response.data.studentAnswers);
      const tempStudentAnswers = response.data.studentAnswers?.map((item) => {
        let tempUploadFiles = [];
        item.uploadedFiles?.map((file) => {
          if (
            file.questionId === response.data.assignmentQuestions[selectedQuestionIndex].questionId
          )
            tempUploadFiles.push(file);
        });

        return { ...item, questionUploadedFiles: tempUploadFiles };
      });

      if (!ferpaEnabled) {
        let randomSort = [...tempStudentAnswers];
        randomSort.sort(() => Math.random() - 0.5);
        setDisplayStudentAnswerData(randomSort);
      } else
        setDisplayStudentAnswerData(tempStudentAnswers);

      setPageLoading(false);
    });
  }

  function handleColumnFilter(e) {
    if (!e.target.id.includes('columnFilter-')) return;

    var filterColumn = e.target.id.split('columnFilter-')[1];

    if (e.target.checked) {
      setSelectedColumnFilters((result) => [...result, filterColumn]);
    } else {
      setSelectedColumnFilters(selectedColumnFilters.filter((c) => c != filterColumn));
    }
  }

  const handleColumnSort = (e) => {
    let sortedStudentAnswers = [...displayStudentAnswerData];

    if (e) {
      sortResultsBy.current = e.target.id;
      sortByAscending.current = !sortByAscending.current;
    }
    switch (sortResultsBy.current) {
    case 'sort-student':
      sortedStudentAnswers = sortedStudentAnswers.sort((a, b) =>
        a.studentFirstName + a.studentLastName > b.studentFirstName + b.studentLastName ? 1 : -1
      );
      break;
    case 'sort-class':
      sortedStudentAnswers = sortedStudentAnswers.sort((a, b) =>
        a.className > b.className ? 1 : -1
      );
      break;
    case 'sort-status':
      sortedStudentAnswers = sortedStudentAnswers.sort(
        (a, b) => a.crQuestionStatus - b.crQuestionStatus
      );
      break;
    case 'sort-score':
      sortedStudentAnswers = sortedStudentAnswers.sort((a, b) => a.score - b.score);
      break;
    case 'sort-retake':
      sortedStudentAnswers = sortedStudentAnswers.sort(
        (a, b) => a.retakeVersion - b.retakeVersion
      );
      break;
    default:
      sortedStudentAnswers = sortedStudentAnswers.sort((a, b) =>
        a.studentFirstName + a.studentLastName > b.studentFirstName + b.studentLastName ? 1 : -1
      );
      break;
    }
    if (!sortByAscending.current) sortedStudentAnswers.reverse();

    setDisplayStudentAnswerData(sortedStudentAnswers);
  };

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    const selected = key !== '000' ? classList.find((v) => v.id == key) : classList;
    if (key === '000') {
      const tempValue = classList.map((item) => ({
        ...item,
        isChecked: !classList.filter((item) => item?.isChecked !== true).length < 1
      }));
      setClassList(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      setSelectedClassIds(ids);
    } else {
      const tempValue = classList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
      setClassList(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      setSelectedClassIds(ids);
    }
  };

  useEffect(() => {
    if (!ferpaEnabled) {
      let randomSort = [...displayStudentAnswerData];
      randomSort.sort(() => Math.random() - 0.5);
      setDisplayStudentAnswerData(randomSort);
    } else {
      handleColumnSort();
    }
  }, [ferpaEnabled]);


  async function handleScoreChange(scoreElement, crAnswer, index) {
    if (scoreElement.value != 0) {
      scoreElement.value = scoreElement.value.replace(/\b0+/g, '');
    }

    var score = scoreElement.value;
    var scoreResponseElement = document.getElementById(`scoreResponse_${index}`);

    if ((!score && score != 0) || score == '') {
      scoreElement.style.setProperty('border', '1px solid #F84646', 'important');
      scoreResponseElement.style.display = 'none';
      return;
    }
    if (score == crAnswer.score) {
      scoreElement.style.setProperty('border', 'none', 'important');
      scoreResponseElement.style.display = 'none';
      return;
    }

    if (isNaN(score) || score < 0 || score > crAnswer.maxPoints) {
      scoreResponseElement.style.display = 'inline';
      scoreResponseElement.style.color = '#F84646';
      scoreResponseElement.innerText = `The score range is 0-${crAnswer.maxPoints}`;
      scoreElement.style.setProperty('border', '1px solid #F84646', 'important');
      return;
    }

    scoreResponseElement.style.display = 'inline';
    scoreResponseElement.style.color = '#F7931E';
    scoreResponseElement.innerText = 'Saving...';

    try {
      var scoreResult = await scoreCrAnswer({
        SessionId: crAnswer.sessionId,
        StudentId: crAnswer.studentId,
        QuestionId: crAnswer.questionId,
        Score: score,
        CourseId: crAnswer.courseId,
        AssignmentId: assignmentId
      }).unwrap();

      // Update value in array
      const tempArray = [...displayStudentAnswerData];
      const crAnswerCopy = structuredClone(crAnswer);
      crAnswerCopy.score = scoreResult.score;
      crAnswerCopy.crQuestionStatus = scoreResult.questionStatus;
      tempArray[index] = crAnswerCopy;
      setDisplayStudentAnswerData(tempArray);

      scoreElement.style.setProperty('border', '1px solid #48E0B2', 'important');
      scoreResponseElement.style.color = '#48E0B2';
      scoreResponseElement.innerText = 'Score saved';
      setTimeout(function () {
        scoreResponseElement.style.display = 'none';
      }, 3000);
    } catch (ex) {
      scoreResponseElement.style.color = '#F84646';
      scoreResponseElement.innerText = 'Score failed to save';
      scoreElement.style.setProperty('border', '1px solid #F84646', 'important');
    }
  }

  async function handleUnfinalizeResponse(crAnswer, index) {
    try {
      let scoreElement = document.getElementById('score' + index);
      scoreElement.value = '';
      scoreElement.style.removeProperty('border');
      var scoreResponseElement = document.getElementById(`scoreResponse_${index}`);
      scoreResponseElement.style.display = 'none';
      var scoreResult = await scoreCrAnswer({
        SessionId: crAnswer.sessionId,
        StudentId: crAnswer.studentId,
        QuestionId: crAnswer.questionId,
        Score: -1,
        CourseId: crAnswer.courseId
      }).unwrap();
      // Update value in array
      const tempArray = [...displayStudentAnswerData];
      const crAnswerCopy = structuredClone(crAnswer);
      crAnswerCopy.score = scoreResult.score;
      crAnswerCopy.crQuestionStatus = scoreResult.questionStatus;
      tempArray[index] = crAnswerCopy;
      setDisplayStudentAnswerData(tempArray);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function handleTeacherCommentChange(comment) {
    var crAnswer = teacherCommentModalData.current.crAnswer;

    var response = await scoreCrAnswer({
      SessionId: crAnswer.sessionId,
      StudentId: crAnswer.studentId,
      QuestionId: crAnswer.questionId,
      CourseId: crAnswer.courseId,
      Comment: comment
    });

    // Update value in array
    const tempArray = [...displayStudentAnswerData];
    const crAnswerCopy = structuredClone(crAnswer);
    if (response.error) {
      if (response.error.data.errors)
        setError(response.error.data.errors.Comment);        
      else
        setError(response.error.data.error);
      return;
    }
    else {
      crAnswerCopy.teacherComment = response.data.comment;
      tempArray[teacherCommentModalData.current.index] = crAnswerCopy;
      setDisplayStudentAnswerData(tempArray);
      setShowTeacherCommentModal(false);
    }
  }
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (filterColumnRef.current && !filterColumnRef.current.contains(event.target)) {
        setShowColumnFilterOptions(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const htmlContentHandler = async (htmContentPath) => {
    const options = { filePath: htmContentPath };
    const result = await getHtmlContent(options);
    if (result.error)
      setHtmContent(result.error.data.error);
    else {
      setHtmContent(result.data.content);
    }
  };

  return (
    <>
      {pageLoading && <LoadingOverlay />}
      <div className="d-flex flex-column assignmentBody">
        <div className="d-flex flex-row align-items-center justify-content-between">
          <h1>CR grading for {assignmentName}</h1>

          <div className="d-flex flex-row align-content-center">
            <div className="d-flex me-3 align-items-center">
              <FERPA />
            </div>
            <button
              onClick={() => window.history.back()}
              className="btn btn-castleWhite btn-width">
              Back
            </button>
          </div>
        </div>

        <Form.Group style={{ width: '17%', marginRight: '0.5vw' }}>
          <Form.Label htmlFor="classDropdown">Class</Form.Label>

          <MultiDropDown
            value={classList}
            setValue={setClassList}
            dropdownId="classesFilter"
            placeholder="Filter Classes"
            handleChange={(e) => handleClassSelectionChange(e)}
            selectedId={selectedClassIds}
            setSelectedId={setSelectedClassIds}
            description={true}
            selectAllText="All Classes"
            coteachertext={true}
          />
        </Form.Group>

        <div className="d-flex flex-row my-3 questionDetails">
          <div className="crQuestionsGrid">
            {assignmentQuestions.map((item, index) => {
              return (
                <button
                  key={`questionButton-${index}`}
                  className={`questionNumberButton ${index == selectedQuestionIndex ? 'active' : ''}`}
                  onClick={() => setSelectedQuestionIndex(index)}>
                  {item.questionIndex}
                </button>
              );
            })}
          </div>

          <div className="d-flex flex-column w-75">
            <Accordion className="d-flex flex-row" style={{ padding: '4px' }}>
              <Accordion.Item className="w-100" eventKey="0">
                <Accordion.Header>
                  <h1 style={{ margin: '0px' }}>Question</h1>
                </Accordion.Header>
                <Accordion.Body>
                  <div className='questionWrapper'
                    dangerouslySetInnerHTML={{
                      __html: assignmentQuestions.at(selectedQuestionIndex)?.question
                    }}></div>
                  {assignmentQuestions.at(selectedQuestionIndex)?.resources.length > 0 && (
                    <>
                      <div
                        className="d-flex reading-block-header"
                        onClick={() => setShowResourceOptions(!showResourceOptions)}>
                        <FontAwesomeIcon className="mx-2" color="#F7931E" icon={faBookOpen} />
                        <div style={{ color: '#F7931E' }}>Reading Passage Ducks</div>
                      </div>
                      <div>
                        {showResourceOptions &&
                          assignmentQuestions
                            .at(selectedQuestionIndex)
                            ?.resources.map((item, index) => {
                              if (item.endsWith('.mp3')) {
                                return (
                                  <div key={index} className="resource-view d-flex justify-content-center">
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                    </audio>
                                  </div>
                                );
                              } else if (item.endsWith('.htm')) {
                                htmlContentHandler(item);
                                return (
                                  <>
                                    <div
                                      key={index}
                                      id={'htmlRes' + index}
                                      dangerouslySetInnerHTML={{ __html: htmContent }}></div>
                                    <br></br>
                                  </>
                                );
                              }
                            })}
                      </div>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion className="d-flex flex-row my-2" style={{ padding: '4px' }}>
              <Accordion.Item className="w-100" eventKey="0">
                <Accordion.Header>
                  <h1 style={{ margin: '0px' }}>Sample Answer</h1>
                </Accordion.Header>
                <Accordion.Body>
                  <div className='questionWrapper'
                    dangerouslySetInnerHTML={{
                      __html: assignmentQuestions.at(selectedQuestionIndex)?.sampleAnswer
                    }}></div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="d-flex flex-row justify-content-end">
              <Button
                disabled={dataError || selectedQuestionIndex == 0}
                onClick={() => setSelectedQuestionIndex(selectedQuestionIndex - 1)}
                className="me-2"
                variant="castleWhite">
                Previous
              </Button>
              <Button
                disabled={dataError || selectedQuestionIndex == assignmentQuestions.length - 1}
                onClick={() => setSelectedQuestionIndex(selectedQuestionIndex + 1)}
                className="castleRedSize"
                variant="castleRed">
                Next
              </Button>
            </div>
          </div>
        </div>

        <Form.Label
          style={{ fontSize: '14px', fontWeight: '500' }}
          className="text-color"
          htmlFor="statusDisplayRadio">
          Display rows for
        </Form.Label>
        <Form.Group id="statusDisplayRadio" className="mb-3">
          <Form.Check
            inline
            name="statusFilterGroup"
            type="radio"
            onChange={() => setStatusFilterOption(0)}
            label="All Answers"
            id="allAnswersRadio"
            defaultChecked="true"
          />
          <Form.Check
            inline
            name="statusFilterGroup"
            type="radio"
            onChange={() => setStatusFilterOption(1)}
            label="Answered / Not Scored"
            id="answeredNotScoredRadio"
          />
          <Form.Check
            inline
            name="statusFilterGroup"
            type="radio"
            onChange={() => setStatusFilterOption(2)}
            label="Inprogress / Not Scored"
            id="inprogressNotScoredRadio"
          />
          <Form.Check
            inline
            name="statusFilterGroup"
            type="radio"
            onChange={() => setStatusFilterOption(3)}
            label="Scored"
            id="scoredRadio"
          />
          <Form.Check
            inline
            name="statusFilterGroup"
            type="radio"
            onChange={() => setStatusFilterOption(4)}
            label="Not Answered"
            id="notAnsweredRadio"
          />
        </Form.Group>

        <div className="d-flex flex-row justify-content-between">
          <Form.Group id="filterStudentName" className="position-relative">
            <Form.Control
              autoComplete="off"
              type="text"
              placeholder="Filter Students"
              style={{ paddingLeft: '40px' }}
              onChange={(e) => setStudentNameFilter(e.target.value)}
            />
            <FontAwesomeIcon className="textboxIcon" icon={faMagnifyingGlass} />
          </Form.Group>

          <div className="d-flex flex-row align-items-center">
            <Form.Check
              id="hideRetakesChk"
              className="me-3"
              type="checkbox"
              label="Hide Retakes"
              onChange={() => setHideRetakes(!hideRetakes)}
            />
            <div ref={filterColumnRef}>
              <button
                className="columnFilterButton"
                onClick={() => setShowColumnFilterOptions(!showColumnFilterOptions)}>
                <FontAwesomeIcon className="mx-2" icon={faTableColumns} color="#F7931E" />
                Filter Columns
              </button>
              <div
                className="columnFiltersContainer"
                style={{ display: showColumnFilterOptions ? 'block' : 'none' }}>
                <div className="d-flex flex-column columnFilters">
                  <Form.Check
                    type="checkbox"
                    onChange={(e) => handleColumnFilter(e)}
                    defaultChecked="true"
                    id="columnFilter-Class"
                    label="Class"
                  />
                  <Form.Check
                    type="checkbox"
                    onChange={(e) => handleColumnFilter(e)}
                    defaultChecked="true"
                    id="columnFilter-Status"
                    label="Status"
                  />
                  <Form.Check
                    type="checkbox"
                    onChange={(e) => handleColumnFilter(e)}
                    defaultChecked="true"
                    id="columnFilter-Score"
                    label="Score"
                  />
                  <Form.Check
                    type="checkbox"
                    onChange={(e) => handleColumnFilter(e)}
                    defaultChecked="true"
                    id="columnFilter-Un-finalize Response"
                    label="Un-finalize Response"
                  />
                  <Form.Check
                    type="checkbox"
                    onChange={(e) => handleColumnFilter(e)}
                    defaultChecked="true"
                    id="columnFilter-Retake"
                    label="Retake"
                  />
                  <Form.Check
                    type="checkbox"
                    onChange={(e) => handleColumnFilter(e)}
                    defaultChecked="true"
                    id="columnFilter-Answer"
                    label="Answer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="custom-table my-3">
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">
                  Student{' '}
                  <button className="sort-btn" onClick={(e) => handleColumnSort(e)}>
                    <FontAwesomeIcon id="sort-student" icon={faSort} />
                  </button>
                </th>
                {selectedColumnFilters.includes('Class') && (
                  <th className="text-center">
                    Class{' '}
                    <button className="sort-btn" onClick={(e) => handleColumnSort(e)}>
                      <FontAwesomeIcon id="sort-class" icon={faSort} />
                    </button>
                  </th>
                )}
                {selectedColumnFilters.includes('Status') && (
                  <th className="text-center">
                    Status{' '}
                    <button className="sort-btn" onClick={(e) => handleColumnSort(e)}>
                      <FontAwesomeIcon id="sort-status" icon={faSort} />
                    </button>
                  </th>
                )}
                {selectedColumnFilters.includes('Score') && (
                  <th className="text-center">
                    Score
                    <button className="sort-btn" onClick={(e) => handleColumnSort(e)}>
                      <FontAwesomeIcon id="sort-score" icon={faSort} />
                    </button>
                  </th>
                )}
                {selectedColumnFilters.includes('Un-finalize Response') && (
                  <th className="text-center">Un-finalize Response</th>
                )}
                {selectedColumnFilters.includes('Retake') && (
                  <th className="text-center">
                    Retake
                    <button className="sort-btn" onClick={(e) => handleColumnSort(e)}>
                      <FontAwesomeIcon id="sort-retake" icon={faSort} />
                    </button>
                  </th>
                )}
                {selectedColumnFilters.includes('Answer') && (
                  <th className="text-center">Answer</th>
                )}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {dataError && (
                <tr>
                  <td colSpan={selectedColumnFilters.length} style={{ textAlign: 'center' }}>
                    <button
                      style={{
                        color: '#F84646',
                        fontSize: '1.15rem',
                        border: 'none',
                        background: 'none'
                      }}
                      onClick={() => {
                        setPageLoading(true);
                        refetch();
                      }}>
                      There was an error getting the data. Click to try again
                    </button>
                  </td>
                </tr>
              )}
              {displayStudentAnswerData &&
                displayStudentAnswerData.map((item, index) => {
                  // filter question id
                  if (item.questionId != assignmentQuestions.at(selectedQuestionIndex).questionId) return;

                  // filter student names
                  if (studentNameFilter && !item.studentFirstName.toLowerCase().includes(studentNameFilter.toLowerCase()) &&
                    !item.studentLastName.toLowerCase().includes(studentNameFilter.toLowerCase())) return;

                  // filter class
                  if (!selectedClassIds.includes(item.classId)) return;

                  if (hideRetakes && item.retakeVersion !== 0) return;

                  let answerStatus =
                    crAnswerStatuses.find((s) => s.statusId == item.crQuestionStatus) ??
                    crAnswerStatuses[0];
                  let answerFilter = true;

                  switch (statusFilterOption) {
                  case 1:
                    answerFilter =
                        [1, 3].includes(item.crQuestionStatus) && !item.score && item.score != 0;
                    break;
                  case 2:
                    answerFilter = item.crQuestionStatus == 2 && !item.score;
                    break;
                  case 3:
                    answerFilter = item.score || item.score == 0 ? true : false;
                    break;
                  case 4:
                    answerFilter = item.crQuestionStatus == 0;
                    break;
                  default:
                    answerFilter = true;
                    break;
                  }

                  if (!answerFilter) return;

                  return (
                    <tr style={{ height: '100px' }} key={`studentAnswerRow_${index}`}>
                      <td className="text-center">
                        {!ferpaEnabled
                          ? 'hidden'
                          : `${item.studentFirstName} ${item.studentLastName}`}
                      </td>
                      {selectedColumnFilters.includes('Class') && (
                        <td className="text-center">{item.className}</td>
                      )}
                      {selectedColumnFilters.includes('Status') && (
                        <td className="text-center">
                          <span
                            className="crAnswerStatus"
                            style={{
                              background: answerStatus.backgroundColor,
                              color: answerStatus.foregroundColor
                            }}>
                            {answerStatus.text}
                          </span>
                        </td>
                      )}
                      {selectedColumnFilters.includes('Score') && (
                        <td className="text-center">
                          <div className="d-flex flex-column align-items-center">
                            <Form.Control
                              id={'score' + index}
                              style={{ maxWidth: '125px', maxHeight: '35px' }}
                              placeholder={`Enter 0-${item.maxPoints}`}
                              onBlur={(e) => handleScoreChange(e.target, item, index)}
                              onKeyUp={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                  handleScoreChange(event.target, item, index);
                                }
                              }}
                              defaultValue={item.score}
                            />
                            <div style={{ position: 'relative', width: '100%' }}>
                              <div
                                id={`scoreResponse_${index}`}
                                className="scoreResponse"
                                style={{ display: 'none' }}></div>
                            </div>
                          </div>
                        </td>
                      )}
                      {selectedColumnFilters.includes('Un-finalize Response') && (
                        <td className="text-center">
                          <OverlayTrigger
                            key={`unfinalizeResponseOverlay-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-unfinalizeResponseOverlay-${index}`}
                                className="custom-tooltip">
                                Un-finalize Response
                                <br />
                                Not scored and change question status to &apos;In Progress&apos;
                              </Tooltip>
                            }>
                            <button
                              type="button"
                              className={`unfinalizeResponseButton ${[1, 3, 4].includes(item.crQuestionStatus)
                                ? 'answered'
                                : 'notAnswered'}`}
                              onClick={() => handleUnfinalizeResponse(item, index)}>
                              <FontAwesomeIcon
                                icon={faFileCircleCheck}
                                color={
                                  [1, 3, 4].includes(item.crQuestionStatus)
                                    ? '#48E0B2'
                                    : '#969696'
                                }
                              />
                            </button>
                          </OverlayTrigger>
                        </td>
                      )}
                      {selectedColumnFilters.includes('Retake') && (
                        <td className="text-center">
                          {item.retakeVersion == 0 ? 'Original' : `Retake ${item.retakeVersion}`}
                        </td>
                      )}
                      {selectedColumnFilters.includes('Answer') && (
                        <td style={{ maxWidth: '400px' }} className="text-center">
                          <div className="d-flex flex-column">
                            <span
                              className="studentAnswer"
                              id={`studentAnswer-${index}`}
                              ref={(elem) => (answerCellRefs.current[index] = elem)}
                              dangerouslySetInnerHTML={{ __html: item.answer }}></span>
                            <div className="d-flex flex-row justify-content-end">
                              <button
                                id={`studentViewAll_${index}`}
                                style={{ display: 'none' }}
                                className="crAnwserViewAllButton"
                                onClick={() => {
                                  studentAnswerModalData.current = item.answer;
                                  setShowViewAllAnswerModal(true);
                                }}>
                                <FontAwesomeIcon
                                  className="me-2"
                                  color="#F7931E"
                                  icon={faSquarePlus}
                                />
                                <span>View All</span>
                              </button>
                            </div>
                          </div>
                        </td>
                      )}

                      <td className="text-center">
                        <div className="d-flex flex-row justify-content-end">
                          <OverlayTrigger
                            key={`uploadedFilesOverlay-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-uploadedFilesOverlay-${index}`}
                                className="custom-tooltip">
                                Student Uploaded Files
                              </Tooltip>
                            }>
                            <button
                              className="crAnswerButtons studentFilesButton me-2"
                              disabled={!item.questionUploadedFiles.length > 0}
                              onClick={() => {
                                studentFilesModalData.current = {
                                  files: item.questionUploadedFiles,
                                  studentName: `${item.studentFirstName} ${item.studentLastName}`
                                };
                                setShowStudentFilesModal(true);
                              }}>
                              <FontAwesomeIcon
                                icon={faPaperclip}
                                style={{ fontSize: '1.25em' }}
                                color={
                                  item.questionUploadedFiles.length > 0 ? '#F1C40F' : '#969696'
                                }
                              />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            key={`teacherCommentOverlay-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-teacherCommentOverlay-${index}`}
                                className="custom-tooltip">
                                Add/Edit Feedback
                              </Tooltip>
                            }>
                            <button
                              className="crAnswerButtons teacherCommentButton"
                              onClick={() => {
                                teacherCommentModalData.current = {
                                  crAnswer: item,
                                  index: index
                                };
                                setShowTeacherCommentModal(true);
                              }}>
                              <FontAwesomeIcon
                                icon={faMessageLines}
                                style={{ fontSize: '1.25em' }}
                              />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>

                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      {showTeacherCommentModal &&
      <TeacherCommentModal
        studentAnswerDetails={teacherCommentModalData.current}
        handleCommentChange={handleTeacherCommentChange}
        show={showTeacherCommentModal}
        onHide={() => setShowTeacherCommentModal(false)}
        error={error}
        setError={setError}
      />
      }
      <StudentUploadedFilesModal
        studentFilesData={studentFilesModalData.current}
        assignmentName={assignmentName}
        show={showStudentFilesModal}
        onHide={() => setShowStudentFilesModal(false)}
        isFerpa={ferpaEnabled}
      />
      <ViewAllStudentAnswerModal
        studentAnswer={studentAnswerModalData.current}
        show={showViewAllAnswerModal}
        onHide={() => setShowViewAllAnswerModal(false)}
      />
    </>
  );
}

export default GradeCrQuestions;
